export default __webpack_public_path__ + "static/media/dessert3.52214249.png";